import { HttpRequest } from '@angular/common/http';

export const csdtAuthApp = 'braintab';

export const cloneAndAddHeaders = (
    req: HttpRequest<unknown>,
    headers: Record<string, string>,
): HttpRequest<unknown> => {
    return req.clone({
        setHeaders: headers,
    });
};
